<script setup>
import dayjs from 'dayjs'
import ja from 'dayjs/locale/ja'
import timezone from 'dayjs/plugin/timezone'
import utc from 'dayjs/plugin/utc'

dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.tz.setDefault('Asia/Tokyo')
dayjs.locale(ja)
defineProps({
  text: { type: String, default: '' },
  link: { type: String, default: '' },
  date: { type: Number, default: null },
  img: { type: String, default: '' }
})
</script>

<template>
  <NuxtLink
    class="livecamBlock"
    :to="link"
  >
    <p class="name">{{ text }}</p>
    <figure class="image">
      <img
        :src="img"
        alt=""
      >
    </figure>
    <p class="date">{{ dayjs.unix(date).tz('Asia/Tokyo').format('M/D HH:mm') }}</p>
  </NuxtLink>
</template>

<style lang="scss" scoped>
.livecamBlock {
  display: flex;
  flex-direction: column;
  padding: 4px 4px 2px 4px;
  gap: 5px;
  border-radius: 6px;
  border: 1px solid #DFE4F0;
  background-color: #FFF;
  .name {
    color: #1F59BA;
    font-size: 15px;
    font-weight: 600;
    line-height: 17px;
    text-decoration: underline;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .image {
    width: 100%;
    aspect-ratio: 4 / 3;
    border-radius: 6px;
    overflow: hidden;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      vertical-align: bottom;
    }
  }
  .date {
    color: #303030;
    text-align: right;
    font-size: 10px;
    line-height: 13px;
  }
  @media (any-hover: hover) {
    transition: opacity .2s ease-in-out;
    cursor: pointer;
    &:hover {
      opacity: .6;
    }
  }
}
</style>
